<template>
    <v-row class="d-flex flex-wrap justify-center mx-2 my-4">
        <v-col md="4" sm="12" v-for="tutorial in tutorials" :key="tutorial.id">
            <VideoCard :elementVideo="tutorial" />
        </v-col>
    </v-row>
</template>

<script>
import VideoCard from './VideoCard.vue';
import { mapState } from 'vuex';

export default {
    name: 'Tutorials',
    components: {
        VideoCard,
    },
    data: () => ({}),
    computed: {
        ...mapState({
            tutorials: (state) => state.tutorials.tutorials,
        }),
    },
};
</script>

<style>
</style>